import {
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

const MultiSelectFieldForObjectState = ({ formInfo, Object, handleChange }) => {
  let label = Object.label;
  let name = Object.name;

  let AboveText = Object.AboveText;

  let selectValues = Object.selectValues;

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    handleChange({
      target: {
        name,
        value: checked ? "Yes" : "No",
      },
    });
  };

  return (
    <>
      {window.innerWidth >= 800 ? (
        <div style={{ fontSize: "1.2rem", color: "black" }}>{AboveText}</div>
      ) : (
        <div style={{ fontSize: "1.2rem", color: "black" }}>
          {AboveText}
          <br></br>
          <i>{label}:</i>
        </div>
      )}
      <FormGroup style={{ textAlign: "left" }}>
        {selectValues.map((value) => (
          <>
            <FormControlLabel
              key={value.name}
              control={
                <Checkbox
                  checked={formInfo[value.name] === "Yes"}
                  onChange={handleCheckboxChange}
                  name={value.name}
                />
              }
              label={value.label}
            />
          </>
        ))}
      </FormGroup>
    </>
  );
};

export default MultiSelectFieldForObjectState;
